module.exports = __webpack_public_path__ + "static/media/VectorMail.5bd9cd4b.svg";